var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import CookieHandler from "./Cookies";
var ShoppingcartHandler = /** @class */ (function () {
    function ShoppingcartHandler() {
        var _this = this;
        // Add Product To Shoppingcart
        // Increase Product in Shoppincart
        // Decrease Product in Shoppincart
        // Remove Product from Shoppingcart
        // Set Total Shoppingcart Price
        this.Init = function (dom, baseUri, forXpwCustomerNumber, userId, shoppingCartId) { return __awaiter(_this, void 0, void 0, function () {
            var $this;
            var _this = this;
            return __generator(this, function (_a) {
                $this = this;
                $this.GetTransportAddresses(dom, baseUri, function (response) { return __awaiter(_this, void 0, void 0, function () {
                    var _this = this;
                    return __generator(this, function (_a) {
                        response.text().then(function (json_text) { return __awaiter(_this, void 0, void 0, function () {
                            var json, holder, i, elements, _loop_1, i;
                            var _this = this;
                            return __generator(this, function (_a) {
                                json = JSON.parse(json_text);
                                holder = dom.getElementById("transportAddresses");
                                // console.log(json["hydra:totalItems"]);
                                // console.log(json["hydra:member"]);
                                for (i = 0; i < json["hydra:totalItems"]; i++) {
                                    $this.CreateTransportCards(dom, holder, json["hydra:member"][i], function () { return __awaiter(_this, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            return [2 /*return*/];
                                        });
                                    }); });
                                }
                                elements = dom.getElementsByClassName("select-location");
                                _loop_1 = function (i) {
                                    var element = elements[0];
                                    var datasetTransport = element.dataset["transportId"];
                                    if (datasetTransport != undefined) {
                                        var transportId_1 = parseInt(datasetTransport);
                                        element.addEventListener("click", function (e) { return __awaiter(_this, void 0, void 0, function () {
                                            var _this = this;
                                            return __generator(this, function (_a) {
                                                element.className += " selected";
                                                $this.SelectTransportAddress(dom, baseUri, function (response) { return __awaiter(_this, void 0, void 0, function () {
                                                    return __generator(this, function (_a) {
                                                        return [2 /*return*/];
                                                    });
                                                }); }, function (response) { return __awaiter(_this, void 0, void 0, function () {
                                                    var _a;
                                                    return __generator(this, function (_b) {
                                                        switch (_b.label) {
                                                            case 0:
                                                                element.className.replace(" selected", "");
                                                                _a = alert;
                                                                return [4 /*yield*/, response.text()];
                                                            case 1:
                                                                _a.apply(void 0, [_b.sent()]);
                                                                return [2 /*return*/];
                                                        }
                                                    });
                                                }); }, transportId_1, userId, shoppingCartId);
                                                return [2 /*return*/];
                                            });
                                        }); });
                                    }
                                };
                                for (i = 0; i < elements.length; i++) {
                                    _loop_1(i);
                                }
                                return [2 /*return*/];
                            });
                        }); });
                        return [2 /*return*/];
                    });
                }); }, forXpwCustomerNumber);
                return [2 /*return*/];
            });
        }); };
        this.ShoppingcartGetProducts = function (baseUri, shoppingcartId, callback) { return __awaiter(_this, void 0, void 0, function () {
            var encodedShoppingcartId, protocol, host, api, response, json;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        encodedShoppingcartId = encodeURIComponent(shoppingcartId);
                        protocol = window.location.protocol;
                        host = window.location.host;
                        api = "".concat(baseUri, "/api/products?hoseProductHB.diameter=").concat(encodedShoppingcartId);
                        return [4 /*yield*/, fetch(api)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        json = _a.sent();
                        callback(json["hydra:member"]);
                        return [2 /*return*/];
                }
            });
        }); };
        this.AddToShoppingcart = function (dom, baseUri, callback, productId, amount, size) {
            if (size === void 0) { size = 1; }
            return __awaiter(_this, void 0, void 0, function () {
                var cookieHandler, encodedProductId, protocol, host, api, response, _a;
                var _this = this;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            cookieHandler = new CookieHandler(document);
                            encodedProductId = encodeURIComponent(productId);
                            protocol = window.location.protocol;
                            host = window.location.host;
                            api = "".concat(baseUri, "/").concat(this.locale, "/shoppingcart/addproduct/").concat(encodedProductId, "/");
                            response = fetch(api, {
                                method: "POST",
                                credentials: 'include',
                                mode: "cors",
                                body: JSON.stringify({
                                    amount: amount,
                                    size: size
                                }),
                                headers: {
                                    "Content-Type": "application/json",
                                },
                            });
                            response.then(function (response) { return __awaiter(_this, void 0, void 0, function () {
                                var cookiehandler, data, e_1;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            cookiehandler = new CookieHandler(document);
                                            if (!(cookieHandler.GetCookie("shoppingcart") == null)) return [3 /*break*/, 4];
                                            _a.label = 1;
                                        case 1:
                                            _a.trys.push([1, 3, , 4]);
                                            return [4 /*yield*/, response.clone().json()];
                                        case 2:
                                            data = _a.sent();
                                            if (data.cartId) {
                                                cookiehandler.SetCookie("shoppingcart", data.cartId, null);
                                            }
                                            return [3 /*break*/, 4];
                                        case 3:
                                            e_1 = _a.sent();
                                            return [3 /*break*/, 4];
                                        case 4: return [2 /*return*/];
                                    }
                                });
                            }); });
                            _a = callback;
                            return [4 /*yield*/, response];
                        case 1:
                            _a.apply(void 0, [_b.sent()]);
                            return [2 /*return*/];
                    }
                });
            });
        };
        this.GetTransportAddresses = function (dom, baseUri, callback, forXpwCustomerNumber) { return __awaiter(_this, void 0, void 0, function () {
            var cookieHandler, encodedCompanyId, protocol, host, api, response;
            return __generator(this, function (_a) {
                cookieHandler = new CookieHandler(document);
                encodedCompanyId = encodeURIComponent(forXpwCustomerNumber);
                protocol = window.location.protocol;
                host = window.location.host;
                api = "".concat(baseUri, "/api/transport_locations?forXpwCustomerNumber=").concat(encodedCompanyId);
                response = fetch(api, {
                    method: "GET",
                    credentials: 'include'
                });
                response.catch(function (error) {
                    // console.log(error);
                });
                response.then(function (r) {
                    // console.log(r);
                    callback(r);
                });
                return [2 /*return*/];
            });
        }); };
        this.AddTransportAddresses = function (dom, baseUri, callback, countryCode, streetName, forXpwCustomerNumber, city, zipcode, streetNumber, streetNumberAddition) {
            if (streetNumberAddition === void 0) { streetNumberAddition = null; }
            return __awaiter(_this, void 0, void 0, function () {
                var cookieHandler, encodedCompanyId, protocol, host, api, response;
                return __generator(this, function (_a) {
                    cookieHandler = new CookieHandler(document);
                    encodedCompanyId = encodeURIComponent(forXpwCustomerNumber);
                    protocol = window.location.protocol;
                    host = window.location.host;
                    api = "".concat(baseUri, "/").concat(this.locale, "/locations/company/add/").concat(encodedCompanyId, "/");
                    response = fetch(api, {
                        method: "POST",
                        credentials: 'include',
                        mode: "cors",
                        body: JSON.stringify({
                            countryCode: countryCode,
                            streetNumber: streetNumber,
                            streetName: streetName,
                            forXpwCustomerNumber: encodedCompanyId,
                            city: city,
                            zipcode: zipcode,
                            streetNumberAddition: streetNumberAddition
                        })
                    });
                    response.then(function (r) {
                        callback(r);
                    });
                    return [2 /*return*/];
                });
            });
        };
        this.CreateTransportCards = function (dom, element, data, callback) { return __awaiter(_this, void 0, void 0, function () {
            var card_element;
            var _a;
            return __generator(this, function (_b) {
                card_element = "<div class=\"p-2\">\n" +
                    "<div class=\"card select-location\" data-transport-id=\"" + data["id"] + "\">\n" +
                    "<div class=\"card-header\">\n" +
                    "<h5 class=\"mb-0\">" + data["locationName"] + "</h5>\n" +
                    "</div>\n" +
                    "<div class=\"card-body\">\n" +
                    "<h5 class=\"card-title mb-0\">Adress :</h5><span>" + data["streetname"] + " " + data["streetnumber"] + ((_a = data["streetnumberaddition"]) !== null && _a !== void 0 ? _a : "") + "</span>\n" +
                    "<h5 class=\"card-title mb-0\">Postcode :</h5><span>" + data["zipcode"] + " " + data["city"] + "</span>\n" +
                    "</div>\n" +
                    "</div>\n" +
                    "</div>";
                element.innerHTML += card_element;
                return [2 /*return*/];
            });
        }); };
        this.SelectTransportAddress = function (dom, baseUri, successCallback, errorCallback, transportId, userId, shoppingCartId) { return __awaiter(_this, void 0, void 0, function () {
            var cookieHandler, protocol, host, api, response;
            return __generator(this, function (_a) {
                cookieHandler = new CookieHandler(document);
                protocol = window.location.protocol;
                host = window.location.host;
                api = "".concat(baseUri, "/").concat(this.locale, "/shoppingcart/transportationaddress/select/").concat(shoppingCartId);
                response = fetch(api, {
                    method: "POST",
                    credentials: 'include',
                    mode: "cors",
                    body: JSON.stringify({
                        transport: transportId,
                        user: userId
                    })
                });
                response.then(function (r) {
                    if (r.status > 500) {
                        return errorCallback(r);
                    }
                    return successCallback(r);
                });
                return [2 /*return*/];
            });
        }); };
        this.SubmitShoppingCart = function (dom, baseUri, callback, shoppingCartId) { return __awaiter(_this, void 0, void 0, function () {
            var cookieHandler, encodeShoppingCartId, protocol, host, api, response;
            return __generator(this, function (_a) {
                cookieHandler = new CookieHandler(document);
                encodeShoppingCartId = encodeURIComponent(shoppingCartId);
                protocol = window.location.protocol;
                host = window.location.host;
                api = "".concat(baseUri, "/").concat(this.locale, "/shoppingcart/submit/");
                response = fetch(api, {
                    method: "POST",
                    credentials: 'include',
                    mode: "cors",
                    body: JSON.stringify({
                        shoppingCart: encodeShoppingCartId
                    })
                });
                response.then(function (r) {
                    callback(r);
                });
                return [2 /*return*/];
            });
        }); };
        // Detect locale from current URL path (e.g. /nl/... or /en/...)
        var match = window.location.pathname.match(/^(?:\/[^/]*)?\/([a-z]{2})\//);
        this.locale = match ? match[1] : 'nl';
    }
    return ShoppingcartHandler;
}());
export default ShoppingcartHandler;
